import type {
  FetchHiringOfficeSearchConfig,
  HiringOfficeSearchQueryParams,
} from "./types";

const DEFAULT_CONFIG = {
  apiEndpoint: "/api/fawkes/geo-search",
};

/**
 * Fetches nearby hiring offices for a geo search term.
 */
async function fetchHiringOfficeSearch(
  {
    location,
    radius = 30,
    forceProximitySearch = false,
  }: HiringOfficeSearchQueryParams,
  { apiEndpoint }: FetchHiringOfficeSearchConfig = DEFAULT_CONFIG,
) {
  if (!location || location.trim() === "") {
    throw new Error("Location is required");
  }

  const searchParams = new URLSearchParams({
    miles: radius.toString(),
    query: location,
  });

  if (forceProximitySearch) {
    searchParams.set("forceProximitySearch", "true");
  }

  let result;
  try {
    const response = await fetch(`${apiEndpoint}?${searchParams}`);

    if (!response.ok) {
      throw new Error(
        `Failed to fetch hiring offices: ${response.status} ${response.statusText}`,
      );
    }

    result = await response.json();
  } catch (error) {
    console.error(error);
    throw new Error("Error fetching hiring offices");
  }

  if (!result.success) {
    throw new Error(result.message || "Error fetching hiring offices");
  }

  return result.data;
}

export { fetchHiringOfficeSearch };
